import PropTypes from 'prop-types';
import React from 'react';
import Button from 'react-bootstrap/lib/Button';
import _ from 'lodash';
import classnames from 'classnames';

import FormError from './Error';

class UploadButton extends React.PureComponent {

    static propTypes = {
        fileName: PropTypes.string,
        bsStyle: PropTypes.string,
        accept: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
        onChange: PropTypes.func,
        error: PropTypes.string,
        children: PropTypes.any.isRequired,
        visited: PropTypes.bool,
        id: PropTypes.string,
        label: PropTypes.string,
        reset: PropTypes.bool,
        onUploadClick: PropTypes.func,
        isDisabled: PropTypes.bool,
        className: PropTypes.string,
        testId: PropTypes.string
    };

    static defaultProps = {
        fileName: null,
        bsStyle: 'default',
        accept: ['image/jpeg', 'image/jpg'],
        onChange: _.noop,
        error: null,
        visited: false,
        id: '',
        label: '',
        reset: false,
        onUploadClick: (callback) => callback(),
        className: ''
    };

    state = {
        visited: this.props.visited
    };

    onFileChange = (event) => {
        const { files } = event.target;
        const [ file ] = files;
        if (file) {
            this.props.onChange(event);
        }
    };

    UNSAFE_componentWillReceiveProps ({ fileName, reset, visited }) {
        if (fileName && fileName !== this.props.fileName) {
            this.setState({ visited: false });
        } else if ( visited !== this.state.visited) {
            this.setState({ visited });
        }
        if (reset && !this.props.reset) {
            this.refs.fileselect.value = '';
        }
    }

    render () {
        const { bsStyle, children, accept, fileName, error, visited, id, label, onUploadClick, isDisabled, className, testId } = this.props;

        const selectFile = () => {
            this.refs.fileselect.click();
        };

        return (
            <div className={ classnames({ 'input--invalid btn-upload-error': !!error }) }>
                <div className="upload__wrapper">
                    <div className="upload-btn__wrapper">
                        <Button bsStyle={ bsStyle }
                            onClick={ () => onUploadClick(selectFile) }
                            disabled={isDisabled}
                            className={className}
                            data-test-id={testId && `${testId}-button`}>
                            { children }
                            <label htmlFor={ id } className="sr-only">{ label }</label>
                            <input id={ id }
                                type="file"
                                ref="fileselect"
                                onChange={ this.onFileChange }
                                style={ { display: 'none' } }
                                data-test-id={testId && `${testId}-input`}
                                accept={ accept }/>
                        </Button>
                        <div className="gradient-overlay" />
                    </div>
                    { fileName && <p className={ classnames('fileName', { 'fileName--accepted': !error }) }
                        data-test-id={testId && `${testId}-file-name-text`}>
                        { fileName }
                    </p> }
                </div>
                { (visited || fileName) && error &&
                    <FormError message={ error } data-test-id={testId && `${testId}-error`} /> }
            </div>
        );
    }

}

export default UploadButton;
